(() => {
  const STORAGE_KEY = 'bb_age_status';
  const ADULT = 'adult';
  const UNDER_18 = 'under18';

  function getStoredStatus() {
    try {
      const value = window.localStorage.getItem(STORAGE_KEY);
      return value === ADULT || value === UNDER_18 ? value : null;
    } catch (error) {
      return null;
    }
  }

  function storeStatus(status) {
    try {
      window.localStorage.setItem(STORAGE_KEY, status);
    } catch (error) {
      document.cookie = `${STORAGE_KEY}=${status}; path=/; max-age=31536000; SameSite=Lax`;
    }
  }

  function updateRestrictedPage(status) {
    const main = document.querySelector(
      'main[data-bb-current-product-restricted="true"]'
    );
    const blockedPage = document.querySelector('[data-bb-age-blocked-page]');

    if (!blockedPage) {
      return;
    }

    const shouldBlock = status === UNDER_18 && Boolean(main);
    blockedPage.hidden = !shouldBlock;
  }

  function applyStatus(status) {
    document.body.classList.toggle('bb-age-adult', status === ADULT);
    document.body.classList.toggle('bb-age-under18', status === UNDER_18);
    document.documentElement.dataset.bbAgeStatus = status || '';
    updateRestrictedPage(status);
  }

  function openGate(gate) {
    gate.hidden = false;
    document.documentElement.classList.add('bb-age-gate-open');

    window.requestAnimationFrame(() => {
      gate.querySelector('[data-bb-age-gate-dialog]')?.focus();
    });
  }

  function closeGate(gate) {
    gate.hidden = true;
    document.documentElement.classList.remove('bb-age-gate-open');
  }

  function initialiseAgeGate() {
    const gate = document.querySelector('[data-bb-age-gate]');

    if (!gate) {
      return;
    }

    const status = getStoredStatus();

    if (status) {
      applyStatus(status);
      closeGate(gate);
    } else {
      openGate(gate);
    }

    gate.querySelector('[data-bb-age-adult]')?.addEventListener('click', () => {
      storeStatus(ADULT);
      applyStatus(ADULT);
      closeGate(gate);
    });

    gate.querySelector('[data-bb-age-under18]')?.addEventListener('click', () => {
      storeStatus(UNDER_18);
      applyStatus(UNDER_18);
      closeGate(gate);
    });

    document.addEventListener('bb:age-gate:reset', () => {
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        document.cookie = `${STORAGE_KEY}=; path=/; max-age=0; SameSite=Lax`;
      }

      document.body.classList.remove('bb-age-adult', 'bb-age-under18');
      openGate(gate);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAgeGate);
  } else {
    initialiseAgeGate();
  }

  document.addEventListener('shopify:section:load', () => {
    applyStatus(getStoredStatus());
  });
})();